import { useCallback, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate, useParams } from "react-router";
import { cultivationDetails as bio } from "../assets/componentDetails";
import { cultivationTabs as tabs } from "../assets/pageTabs";
import CompaniesFeed from "../components/CompaniesFeed";
import GridController from "../components/GridController";
import Header from "../components/Header";
import ProgramFeed from "../components/ProgramFeed";
import usePageReset from "../hooks/usePageReset";
import structuredData from "../assets/structuredText";

export default function Cultivation() {
  const { cultivationTab } = useParams();
  const [displayed, setDisplayed] = useState<string>((cultivationTab as string) || "programs");

  const navigate = useNavigate();

  const chooseTab = useCallback((tabId: string) => {
    setDisplayed(tabId);
  }, []);

  usePageReset();

  useEffect(() => {
    const tabFound = tabs.find((tab) => tab.id === cultivationTab);
    if (tabFound) setDisplayed(cultivationTab as string);
    if (!tabFound && cultivationTab) navigate(`/404`);
  }, [cultivationTab, setDisplayed]);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="keywords" content="programs clients cultiv cultivation" />
        <meta
          name="description"
          content="Learn how we cultivate startups and empower businesses to grow
and reach their full potential, through different entrepreneurship programs and
Cultiv Bureau"
        />
        <meta name="robots" content="index, follow" />
        <meta property="og:url" content="https://cultiv.llc" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          itemProp="image"
          content="https://cultiv.llc/images/metaimg.jpg"
        />
        <link rel="image_src" itemProp="image" href="https://cultiv.llc/images/metaimg.jpg" />
        <meta
          property="og:description"
          content="Learn how we cultivate startups and empower businesses to grow
and reach their full potential, through different entrepreneurship programs and
Cultiv Bureau."
        />
        <meta property="og:site_name" content="Cultiv LLC" />
        <meta property="og:title" content="Cultiv | Cultivation" />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://cultiv.llc" />
        <meta property="twitter:title" content="Cultiv | Cultivation" />
        <meta
          property="twitter:description"
          content=" Learn how we cultivate startups and empower businesses to grow
and reach their full potential, through different entrepreneurship programs and
Cultiv Bureau."
        />
        <meta property="twitter:image" content="https://cultiv.llc/images/metaimg.jpg" />
        <link rel="canonical" href="https://cultiv.llc" />
        <script type="application/ld+json">{structuredData}</script>
        <title>Cultivation</title>
      </Helmet>
      <div className="w-full flex flex-col justify-center items-center lg:gap-10 gap-6">
        <Header desc={bio.text} color="bg-cultiv-sky" />
        <div className="flex flex-col lg:gap-10 gap-6 justify-center items-center w-full  md:px-15 lg:px-20 xl:px-30 px-6">
          <GridController
            displayed={displayed}
            setDisplayed={chooseTab}
            tabs={tabs}
            page="cultivation"
          />
          {displayed === "programs" ? <ProgramFeed /> : <CompaniesFeed relationType={displayed} />}
        </div>
      </div>
    </>
  );
}
